export enum PaymentTypesTag {
    CREDIT_CARD = 'CREDIT_CARD',
    SDD = 'SDD',
    RIBA = 'RIBA',
    BANK_TRANSFER = 'BANK_TRANSFER',
    IBAN_FOR_RIBA_OR_SDD = 'IBAN_FOR_RIBA_OR_SDD',
    TRAVEL_FUND = 'TRAVEL_FUND',
}
